__turbopack_context__.v({
  "beszelStatsContainer": "component-module__vttGEq__beszelStatsContainer",
  "beszelStatsSystemToggle": "component-module__vttGEq__beszelStatsSystemToggle",
});
